import { LABEL_TYPE_OPTIONS } from "../../constants/materialRequirements"

import type { LabelType, LocationMaterialRequirementsPreference } from "@/graphql/codegen/graphql"

export const getShelfLifeDisplay = (data: LocationMaterialRequirementsPreference): string => {
  if (!data.shelfLifeRequired) {
    return "No"
  }
  if (data.shelfLifeRequirement !== null) {
    return `Yes, ${data.shelfLifeRequirement}%`
  }
  return "Yes"
}

export const getLabelConfigurationDisplay = (labelConfiguration: LabelType[] | null | undefined): string => {
  if (!labelConfiguration || labelConfiguration.length === 0) {
    return "-"
  }
  return labelConfiguration
    .map((labelType) => LABEL_TYPE_OPTIONS.find((opt) => opt.value === labelType)?.label)
    .filter(Boolean)
    .join(", ")
}
